import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { updateBlogs, addBlogs, getBlogsBySlug } from "../../api/blogs";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();

  const getWorkQuery = useQuery({
    queryKey: [{ id }],
    queryFn: getBlogsBySlug,
    enabled: !!id,
  });

  const updateWorkQuery = useMutation({ mutationFn: updateBlogs });
  const addWorkItemQuery = useMutation({ mutationFn: addBlogs });

  const initialValues = useMemo(() => {
    const [workAddData] = getWorkQuery?.data?.data?.data || [];
    return {
      works: {
        meta_title: workAddData?.meta_title || "",
        slug_url: workAddData?.slug_url || "",
        meta_description: workAddData?.meta_description || "",
        meta_keywords: workAddData?.meta_keywords || "",
        title: workAddData?.heading || "",
        is_publish: workAddData?.is_published || false,
        keywords: workAddData?.keywords || "",
        description: workAddData?.description || "",
        banner_img: workAddData?.banner_image || "",
        author: workAddData?.author || "",
        rating: workAddData?.rating || "",
        alt_tag:workAddData?.alt_tag || "",
      },
    };
  }, [getWorkQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      meta_title: values?.works?.meta_title || "",
      slug_url: values?.works?.slug_url || "",
      meta_keywords: values?.works?.meta_keywords || "",
      meta_description: values?.works?.meta_description || "",
      heading: values?.works?.title || "",
      is_published: values?.works?.is_publish,
      description: values?.works?.description || "",
      keywords: values.works?.keywords || "",
      banner_image: values.works?.banner_img || "",
      author: values?.works?.author || "",
      alt_tag: values?.works?.alt_tag || "",
      rating: values?.works?.rating || "",
    };

    if (id) {
      payload.id = id;
      updateWorkQuery.mutate(payload, {
        onSuccess: () => {
          getWorkQuery.refetch();
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
        },
      });
      return;
    }
    addWorkItemQuery.mutate(payload, {
      onSuccess: () => {
        navigate(-1);
        toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_ADDED_SUCCESSFULLY);
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
        id,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
